import React from 'react';
import SMOScheduleEditView from './SMOScheduleEditView';
import SMOReservationEditView from './SMOReservationEditView';
import SMConst from 'lib/SMConst';

class SMOBlockEditView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      reservationBlockType: SMConst.ReservationBlockType.Unavailable,
    };
  }
  
  radioButtonDidChangeValue(e) {
    this.setState({
      reservationBlockType: e.currentTarget.value,
    });
  }

  render() {
    if (this.state.reservationBlockType == SMConst.ReservationBlockType.Unavailable) {
      return (
        <SMOScheduleEditView
          delegate={this}
          action={this.props.action}
          owner={this.props.owner}
          initialSpaceId={this.props.initialSpaceId}
          initialRoomId={this.props.initialRoomId}
          initialStartedDate={this.props.initialStartedDate}
          initialEndedDate={this.props.initialEndedDate}
          scheduleId={this.props.scheduleId}
        />
      );
    } else {
      return (
        <SMOReservationEditView
          delegate={this}
          controller={this.props.controller}
          action={this.props.action}
          owner={this.props.owner}
          mediator={SMConst.ReservationMediator.OwnerDirect}
          initialSpaceId={this.props.initialSpaceId}
          initialRoomId={this.props.initialRoomId}
          initialStartedDate={this.props.initialStartedDate}
          initialEndedDate={this.props.initialEndedDate}
        />
      );
    }
  }
  
}
export default SMOBlockEditView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOBlockEditView.jsx